import {isMobile} from 'react-device-detect';

export const getStyle = (styleName: string) => {
  if (isMobile) {
    return styleName + '-mob';
  }

  return styleName;
};

export const spinnerColor = '#81E727';

export const selectStyles = (props: any) => {
  return {
    container: (base: any, state: any) => {
      const container = props.container ? props.container(base, state) : {};
      return {
        ...base, ...{...{zIndex: 1, borderColor: (state.isFocused ? '#E4EAF0' : '#E4EAF0'), ...container}},
      };
    },
    control: (base: any, state: any) => {
      const control = props.control ? props.control(base, state) : {};

      return {
        ...base, ...{...{
            'transition': '.5s',
            'boxShadow': 'none',
            'borderColor': (state.isFocused ? '#81E727' : '#E4EAF0'),
            '&:hover': {
              cursor: 'pointer',
              border: '1px solid #00CCCC',
            },
            '&:focus': {
              outline: 'none',
            },
          },
          ...control}};
    },
    option: (base: any, state: any) => ({
      ...base, ...{
        'display': 'flex',
        'transition': '.5s',
        'fontSize': 14,
        'textAlign': 'center',
        'backgroundColor': (state.isSelected ? '#81E727' : state.isFocused ? '#c4ff98' : 'white'),
        'borderBottom': state.data.isLastGeneral ? '#8a8a8a solid 2px' : undefined,
        '&:hover': {
          cursor: 'pointer',
        },
      },
    }),
    menuList: (base: any, state: any) => ({
      ...base, ...{
        margin: 0,
        padding: 0,
        borderRadius: '4px',
      },
    }),
    indicatorSeparator: (base: any) => ({
      ...base, ...{width: '0px'},
    }),
    clearIndicator: (base: any) => ({
      ...base, ...{color: '232326'},
    }),
    dropdownIndicator: (base: any) => ({
      ...base, ...{color: '#232326'},
    }),
    placeholder: (base: any) => ({
      ...base, ...{color: '#232326'},
    }),
    multiValue: (base: any) => ({
      ...base, ...{backgroundColor: '#E4EAF0', height: 24, borderRadius: '4px'},
    }),
    multiValueLabel: (base: any) => ({
      ...base, ...{borderRadius: '4px', padding: 0, paddingLeft: '3px', height: 24, display: 'flex', alignItems: 'center'},
    }),
  };
};
